import { useState, useEffect } from 'react';
import { Container, Card, Table, Spinner } from 'react-bootstrap';
import { getMyRewards } from '../../api/walletApi';
import { fmtIST } from '../../utils/dateFormat';

const cyan = '#00e5ff';
const cardDark = {
  background: 'radial-gradient(ellipse at 100% 0%, rgba(0,229,255,0.08) 0%, #0d0d0d 65%)',
  border: '1px solid rgba(0,229,255,0.2)',
  color: '#fff',
};
const th = { color: cyan, fontWeight: 600, fontSize: 13, padding: '12px 20px', border: 'none', whiteSpace: 'nowrap' };

const Rewards = () => {
  const [balance, setBalance] = useState(null);
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    getMyRewards()
      .then((res) => {
        setBalance(res.data.balance);
        setTransactions(res.data.transactions);
      })
      .catch((err) => setError(err.response?.data?.message || 'Failed to load rewards.'))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return (
    <Container className="mt-5 text-center">
      <Spinner animation="border" style={{ color: cyan }} />
    </Container>
  );

  return (
    <div style={{ minHeight: '100vh', background: '#0a0a0a', paddingBottom: 40 }}>
      <Container className="pt-4">
        <h5 style={{ color: '#fff', fontWeight: 700, marginBottom: 4 }}>Rewards</h5>
        <div style={{ color: '#888', fontSize: 13, marginBottom: 24 }}>
          Periodical rewards credited to your reward wallet.
        </div>

        {error && (
          <div style={{ color: '#ff6666', background: 'rgba(200,50,50,0.12)', border: '1px solid rgba(200,50,50,0.3)', borderRadius: 8, padding: '12px 16px', marginBottom: 16, fontSize: 13 }}>
            {error}
          </div>
        )}

        {/* Balance card */}
        <Card style={cardDark} className="p-4 mb-4" >
          <div style={{ color: '#888', fontSize: 12, marginBottom: 6 }}>Total Rewards Earned</div>
          <div>
            <span style={{ fontSize: 36, fontWeight: 800, color: 'rgb(0, 229, 255)', textShadow: '0 0 18px rgba(0,229,255,0.35)' }}>
              {balance ?? '—'}
            </span>
            <span style={{ color: '#aaa', fontSize: 14, marginLeft: 8 }}>USDT</span>
          </div>
        </Card>

        {/* Transaction history */}
        <div style={{ color: '#aaa', fontSize: 13, fontWeight: 600, marginBottom: 12 }}>Reward History</div>
        <div style={{ borderRadius: 12, overflow: 'hidden', border: '1px solid rgba(0,229,255,0.12)' }}>
          <Table responsive className="mb-0" style={{ background: 'transparent' }}>
            <thead>
              <tr style={{ background: 'rgba(0,229,255,0.07)', borderBottom: '1px solid rgba(0,229,255,0.15)' }}>
                <th style={th}>Reward</th>
                <th style={th}>Amount (USDT)</th>
                <th style={th}>Date</th>
              </tr>
            </thead>
            <tbody>
              {transactions.length === 0 ? (
                <tr>
                  <td colSpan={3} style={{ color: '#555', textAlign: 'center', padding: '32px', border: 'none' }}>
                    No rewards yet
                  </td>
                </tr>
              ) : (
                transactions.map((txn) => (
                  <tr
                    key={txn._id}
                    style={{ borderBottom: '1px solid rgba(255,255,255,0.05)' }}
                  >
                    <td style={{ color: '#fff', fontSize: 13, padding: '14px 20px', border: 'none', whiteSpace: 'nowrap' }}>
                      {txn.comments || 'Reward'}
                    </td>
                    <td style={{ color: '#66ff99', fontWeight: 700, fontSize: 14, padding: '14px 20px', border: 'none', whiteSpace: 'nowrap' }}>
                      +{txn.amount}
                    </td>
                    <td style={{ color: '#888', fontSize: 12, padding: '14px 20px', border: 'none', whiteSpace: 'nowrap' }}>
                      {fmtIST(txn.createdAt)}
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </Table>
        </div>
      </Container>
    </div>
  );
};

export default Rewards;
